import request from '@/utils/request'

//获取用户国家/地区
export const getCountry = () => {
    return request.get('country');
}